<template>
    <div class="weapp-div">
        <wx-open-launch-weapp
            username="gh_d44f17007344"
            :path="path"
            @launch="handleLaunchFn"
            @error="handleErrorFn"
        >
            <script type="text/wxtag-template">
            <style>
                .weapp{
                    width: 100%;
                    height: 100%;
                    border-radius: 12px;
                    opacity: 0;
                }
                .weapp:active{
                    background: none;
                }
            </style>
            <span class="weapp"> 去点餐</span>
            </script>
        </wx-open-launch-weapp>
    </div>
</template>

<script>
export default {
    name:"weapp",
    props: {
        path: String
    },
    methods:{
        handleLaunchFn(e) {
            console.log('success', e);
        },
        handleErrorFn(e) {
            console.log('fail', e.detail);
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/weapp.vue